import { useContext, useEffect, useState } from "react";
import { CWClientContext } from "../../App";
import BarChartBoard from "./premitive/BarChartBoard";
import { SimpleStatistics } from "../../library/CosmeWidgetAPIClient";
import PageLoading from "../PageLoading";
import { MediaName, MediaTheme } from "../../CosmeWidgetTheme";


type ArchivePerDayProp = {
    className?: string,
}




const ArchivePerDay = (prop: ArchivePerDayProp) => {
    const cwClient = useContext(CWClientContext);
    const [archiveStat, setArchiveStat] = useState<SimpleStatistics[]>();

    useEffect(() => {
        cwClient.getArchiveStatistics().then((res) => {
            console.log(res);
            setArchiveStat(res);
        });
    }, []);

    if (archiveStat === undefined) {
        return (<PageLoading message="データを取得中です" />);
    }

    return (
        <>
            <BarChartBoard
                title="更新数推移"
                data={archiveStat}
                nameDict={MediaName}
                colorMap={MediaTheme}
            ></BarChartBoard>
        </>
    );


};


export default ArchivePerDay;